/**
 * Optional API origin when the frontend and backend are not on the same host.
 *
 * Create `client/.env` with e.g.:
 *   REACT_APP_API_URL=https://your-api.example.com
 *
 * Leave unset (or empty) for local development: requests use `/api/...` on the
 * same origin and CRA proxies to `client/package.json` → `proxy`.
 */
function normalizeApiBase(raw) {
  if (raw == null || raw === '') return '';
  return String(raw).trim().replace(/\/$/, '');
}

export const REACT_APP_API_URL = normalizeApiBase(process.env.REACT_APP_API_URL);

/**
 * @param {string} path Path beginning with '/', e.g. '/api/chat/message'
 * @returns {string} Absolute or same-origin path for axios/fetch
 */
export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  return REACT_APP_API_URL ? `${REACT_APP_API_URL}${p}` : p;
}
